// This is a scaffold for your new Reminders page based on your requirements
// Save this as RemindersPage.js and integrate into your routing system

import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  getDocs,
  doc,
  deleteDoc,
  onSnapshot,
  query,
  where,
  updateDoc,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import "./RemindersPage.css";

const RemindersPage = () => {
  const [lists, setLists] = useState([]);
  const [showListForm, setShowListForm] = useState(false);
  const [newListName, setNewListName] = useState("");
  const [selectedList, setSelectedList] = useState(null);
  const [reminders, setReminders] = useState([]);
  const [newReminderNote, setNewReminderNote] = useState("");
  const [showAddReminder, setShowAddReminder] = useState(false);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, "reminders"), (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setLists(data);
    });
    return () => unsubscribe();
  }, []);

  const openList = (listId) => {
    const selected = lists.find((l) => l.id === listId);
    setSelectedList(selected);
    const q = query(collection(db, `reminders/${listId}/items`), where("completed", "==", false));
    onSnapshot(q, (snapshot) => {
      const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setReminders(data);
    });
  };

  const addNewList = async () => {
    if (!newListName) return;
    await addDoc(collection(db, "reminders"), {
      listName: newListName,
      flaggedCount: 0,
      completedCount: 0,
    });
    setNewListName("");
    setShowListForm(false);
  };

  const deleteList = async (id) => {
    if (!window.confirm("Are you sure you want to delete this list?")) return;
    await deleteDoc(doc(db, "reminders", id));
  };

  const addReminder = async () => {
    if (!newReminderNote || !selectedList) return;
    await addDoc(collection(db, `reminders/${selectedList.id}/items`), {
      note: newReminderNote,
      completed: false,
      flagged: false,
      timestamp: Date.now(),
    });
    setNewReminderNote("");
    setShowAddReminder(false);
  };

  const toggleComplete = async (reminderId) => {
    const reminderRef = doc(db, `reminders/${selectedList.id}/items`, reminderId);
    await updateDoc(reminderRef, { completed: true });
  };

  const renderListView = () => (
    <div className="reminder-list-view">
      <button onClick={() => setSelectedList(null)} className="return-button">
        ⬅️ Return to Lists
      </button>
      <h2>{selectedList?.listName}</h2>
      <div className="reminders-container">
        {reminders.map((rem) => (
          <div key={rem.id} className={`reminder-note`}>
            <input
              type="checkbox"
              onChange={() => toggleComplete(rem.id)}
              style={{ marginRight: 10 }}
            />
            <span>{rem.note}</span>
          </div>
        ))}
      </div>
      {showAddReminder && (
        <div className="new-reminder-popup">
          <textarea
            placeholder="Add Note"
            value={newReminderNote}
            onChange={(e) => setNewReminderNote(e.target.value)}
          />
          <button onClick={addReminder}>Save</button>
        </div>
      )}
      <button
        className="sticky-add-reminder"
        onClick={() => setShowAddReminder(!showAddReminder)}
      >
        + Add New Reminder
      </button>
    </div>
  );

  return (
    <div className="reminders-page">
      {!selectedList ? (
        <>
          <div className="reminders-buttons">
            <button className="orange-button" onClick={() => setShowAddReminder(true)}>
              + Add New Reminder
            </button>
            <button className="orange-button" onClick={() => setShowListForm(true)}>
              + Add List
            </button>
          </div>

          {showListForm && (
            <div className="modal">
              <h3>New List</h3>
              <input
                placeholder="List Name"
                value={newListName}
                onChange={(e) => setNewListName(e.target.value)}
              />
              <button onClick={addNewList}>Save</button>
            </div>
          )}

          <table className="list-table">
            <thead>
              <tr>
                <th>List Name</th>
                <th>Flagged</th>
                <th>Completed</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {lists.map((list) => (
                <tr key={list.id}>
                  <td onClick={() => openList(list.id)}>{list.listName}</td>
                  <td>{list.flaggedCount || 0}</td>
                  <td>{list.completedCount || 0}</td>
                  <td>
                    <button
                      onClick={() => deleteList(list.id)}
                      className="red-button"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      ) : (
        renderListView()
      )}
    </div>
  );
};

export default RemindersPage;
